import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('quick_start_wizard_build_your_first_workflow'),
    description: defineMessage('just_answer_a_few_quest_ercharge_your_approvals'),
    button: defineMessage('lets_start'),
};
